import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import SweetAlert from 'helpers/alert';
import Hls from 'hls.js';

/* eslint-disable jsx-a11y/media-has-caption */
function VideoPlayer({ shortLink, videoTitle, playbackId }) {
  const videoRef = useRef(null);
  const src = `https://stream.mux.com/${playbackId}.m3u8`;

  const showShortLink = () => {
    SweetAlert({
      title: 'Shortlink',
      text: `15vt.short.gy/${shortLink}`,
    });
  };

  useEffect(() => {
    let hls;
    if (videoRef.current) {
      const video = videoRef.current;

      if (video.canPlayType('application/vnd.apple.mpegurl')) {
        // Some browers (safari and ie edge) support HLS natively
        video.src = src;
      } else if (Hls.isSupported()) {
        // This will run in all other modern browsers
        hls = new Hls();
        hls.loadSource(src);
        hls.attachMedia(video);
      } else {
        console.error("This is a legacy browser that doesn't support MSE");
      }
    }

    return () => {
      if (hls) {
        hls.destroy();
      }
    };
  }, [videoRef]);

  return (
    <div
      style={{
        paddingTop: '100px',
      }}
    >
      <div className="py-5 text-center">
        <h2>{videoTitle}</h2>
        <div>
          <Button
            type="submit"
            className="btn btn-secondary-color-1 mb-2"
            onClick={showShortLink}
          >
            Show Shortlink
          </Button>
        </div>
        <video
          controls
          ref={videoRef}
          style={{ width: '100%', maxWidth: '1000px' }}
        />
      </div>
    </div>
  );
}

VideoPlayer.propTypes = {
  shortLink: PropTypes.string.isRequired,
  videoTitle: PropTypes.string.isRequired,
  playbackId: PropTypes.string.isRequired,
};

export default VideoPlayer;
